import { FC, ReactNode } from 'react'
import { SideoverState } from '@/states'
import { useImage } from '@/hooks'
import { ImageOnDrag } from '@/helpers'
import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/16/solid'

const Uploaded: FC<UploadedComponentProps> = (props): ReactNode => {
    const { target } = props
    const { Form, SetState, Loading } = SideoverState()

    const {
        error: isVideoError,
        setError: setVideoIsError
    } = useImage()

    const {
        error: isImageError,
        setError: setImageIsError
    } = useImage()

    let CurrentUploadPreview: any = ''

    if (Form[target] && (Form[target] instanceof Blob || Form[target] instanceof MediaSource)) {
        CurrentUploadPreview = URL.createObjectURL(Form[target])
    }

    else if (typeof Form[target] === 'string' && Form[target].length !== 0) CurrentUploadPreview = Form[target]

    const RemoveAsset = () => {
        if (!Loading) {
            SetState({
                Form:
                {
                    ...Form,
                    [target]: ''
                }
            })
        }
    }

    if (Form[target]) return (
        <div className={`select-none flex flex-col items-center justify-center w-full h-48 border-2 border-[#424242] border-dashed rounded-md bg-[#404040] relative transition-all ease-in-out duration-500 ${Form[target] ? '' : 'hover:opacity-75'}`}>
            <div onClick={RemoveAsset} className='bg-[#4e4e4e] w-6 h-6 absolute border border-[#505050] top-2 right-2 rounded-md flex justify-center items-center hover:opacity-75 transition-all ease-in-out duration-500 cursor-pointer z-10'>
                <XMarkIcon className='flex-shrink-0 w-5 h-5 text-[#EBEBEB]' />
            </div>

            {
                target === 'Image' &&
                <img
                    src={CurrentUploadPreview}
                    onDragStart={ImageOnDrag}
                    className='w-full h-full object-cover rounded-md'
                    alt='Upload'
                    onLoad={() => setImageIsError(false)}
                    style={isImageError ? { display: 'none' } : {}}
                    onError={() => setImageIsError(true)}
                />
            }

            {
                target === 'Image' &&
                isImageError &&
                <div className='flex flex-col items-center justify-center pt-5 pb-6'>
                    <InformationCircleIcon className='text-[#9a9d9e] h-5 w-5' />

                    <p className='text-sm text-[#EBEBEB] mt-2'>
                        <span className='font-semibold'>Image</span> cannot be displayed.
                    </p>

                    <p className='text-xs text-[#9a9d9e] w-[75%] text-center'>
                        This image sems to be broken. Replace it with a new one.
                        To remove it click <span className='px-1.5 py-0.5 text-xs font-semibold text-[#EBEBEB] bg-[#4e4e4e] border border-[#424242] rounded-md'>x</span> button.
                    </p>
                </div>
            }

            {
                target === 'Video' &&
                <video
                    src={CurrentUploadPreview}
                    muted
                    loop
                    autoPlay
                    onError={() => setVideoIsError(true)}
                    onLoadedData={() => setVideoIsError(false)}
                    style={isVideoError ? { display: 'none' } : {}}
                    className='w-full h-full object-cover rounded-md'
                />
            }

            {
                target === 'Video' &&
                isVideoError &&
                <div className='flex flex-col items-center justify-center pt-5 pb-6'>
                    <InformationCircleIcon className='text-[#9a9d9e] h-5 w-5' />

                    <p className='text-sm text-[#EBEBEB] mt-2'>
                        <span className='font-semibold'>Video</span> cannot be displayed.
                    </p>

                    <p className='text-xs text-[#9a9d9e] w-[75%] text-center'>
                        This video sems to be broken. Replace it with a new one.
                        To remove it click <span className='px-1.5 py-0.5 text-xs font-semibold text-[#EBEBEB] bg-[#4e4e4e] border border-[#424242] rounded-md'>x</span> button.
                    </p>
                </div>
            }
        </div>
    )
}

export default Uploaded
